// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1wz_N","topBottomGutter":"Layout_topBottomGutter___pK08"};